import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative bg-accent py-32 lg:py-40 overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-30">
        <div className="absolute top-10 left-10 w-64 h-64 border border-primary/10 rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 border border-primary/10 rounded-full"></div>
      </div>

      <div className="relative w-full px-12 lg:px-20">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-secondary/60 uppercase mb-6">
              Vamos Conversar
            </span>
            <h2 className="text-3xl lg:text-4xl font-medium text-primary leading-tight mb-8">
              Pronto para elevar<br />
              suas operações?
            </h2>
            <p className="text-secondary text-lg lg:text-xl leading-relaxed max-w-2xl mx-auto mb-12">
              Entre em contato e receba um orçamento personalizado através do Grupo Prime e suas empresas especializadas.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/contato"
                className="inline-flex items-center gap-3 bg-primary text-white font-semibold text-sm px-10 py-5 rounded-full hover:bg-primary/90 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Solicitar Orçamento
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
              <a
                href="https://wa.me/5541997438126"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#25D366] text-white font-semibold text-sm px-10 py-5 rounded-full hover:bg-[#20BA5A] hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                WhatsApp
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
